import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_HREF } from "@/lib/contact";

const FAST_LINKS = [
  { label: "VCE English Tutoring", to: "/vce-english-tutoring-melbourne", testId: "footer-link-vce-english" },
  { label: "Small Group Classes", to: "/vce-english-small-group-classes", testId: "footer-link-small-group" },
  { label: "EAL Tutoring", to: "/eal-tutoring-melbourne", testId: "footer-link-eal" },
  { label: "Free Text Guides", to: "/guides", testId: "footer-link-guides" },
  { label: "Contact", to: "/contact", testId: "footer-link-contact" },
  { label: "About Us", to: "/#about", testId: "footer-link-about" },
];

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/yahav.vce/", icon: Instagram, testId: "footer-link-instagram" },
  { label: "Facebook", href: "https://www.facebook.com/tutorsmelbourne", icon: Facebook, testId: "footer-link-facebook" },
];

export const SiteFooter = () => (
  <footer className="bg-slate-50 dark:bg-[#0a0b10] border-t border-slate-100 dark:border-slate-800 py-14 px-6" data-testid="site-footer">
    <div className="max-w-7xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div>
          <p className="font-heading text-lg font-bold text-brand-purple dark:text-brand-purple-light">Tutors Melbourne</p>
          <p className="text-sm text-brand-gold font-body font-semibold">Learning Perfected</p>
          <p className="text-sm text-slate-500 dark:text-slate-400 font-body mt-3 max-w-xs">
            Small group English classes for Year 7–12 — hybrid model: online or in-person across Melbourne.
          </p>
        </div>

        <div>
          <p className="font-heading text-sm font-bold text-slate-900 dark:text-white mb-3">Fast links</p>
          <ul className="space-y-2">
            {FAST_LINKS.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm font-body text-slate-500 dark:text-slate-400 hover:text-brand-purple dark:hover:text-brand-purple-light transition-colors" data-testid={l.testId}>
                  {l.label}
                </Link>
              </li>
            ))}
            {SOCIALS.map((s) => (
              <li key={s.label}>
                <a href={s.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-sm font-body text-slate-500 dark:text-slate-400 hover:text-brand-purple dark:hover:text-brand-purple-light transition-colors" data-testid={s.testId}>
                  <s.icon className="h-3.5 w-3.5" /> {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-heading text-sm font-bold text-slate-900 dark:text-white mb-3">Get in touch</p>
          <a href={PHONE_HREF} className="inline-flex items-center gap-2 text-sm font-body font-semibold text-slate-600 dark:text-slate-300 hover:text-brand-purple transition-colors" data-testid="footer-phone">
            <Phone className="h-3.5 w-3.5" /> {PHONE_DISPLAY}
          </a>
          <a href="mailto:hello@tutorsmelbourne.com.au" className="inline-flex items-center gap-2 text-sm font-body text-slate-500 dark:text-slate-400 hover:text-brand-purple transition-colors mt-2" data-testid="footer-email">
            <Mail className="h-3.5 w-3.5" /> hello@tutorsmelbourne.com.au
          </a>
          <div className="mt-4">
            <Link to="/enrol" className="text-sm font-body font-semibold text-brand-gold hover:underline" data-testid="footer-enrol-link">
              Enrol now →
            </Link>
          </div>
        </div>
      </div>

      <p className="text-xs text-slate-400 dark:text-slate-500 font-body mt-10 pt-6 border-t border-slate-200 dark:border-slate-800">
        &copy; {new Date().getFullYear()} Tutors Melbourne. All rights reserved.
      </p>
    </div>
  </footer>
);

export default SiteFooter;
